import React, { Component } from "react";
import { Route } from "react-router";
import { Layout } from "./components/Layout";
import LogIn from "./components/Login/LogIn";
import EventCalander from "./components/Calander/EventCalander";
import Service from "./components/Service/Service";
import SalonConfig from "./components/Config/SalonConfig";
import EditProfile from "./components/Profile/EditProfile";
import { Switch, Redirect } from "react-router";

import "./custom.css";
import Bill from "./components/Report/Bill";
import Salary from "./components/Salary/Salary";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout>
        <Switch>
          <Route exact path="/" component={LogIn} />
          <Route path="/service" component={Service} />
          <Route path="/eventCalander" component={EventCalander} />
          <Route path="/salonConfig" component={SalonConfig} />
          <Route path="/editProfile" component={EditProfile} />
          <Route path="/bill" component={Bill} />
          <Route path="/salary" component={Salary} />
          
          {/* 所有不存在的路徑導回登入 */}
          <Redirect to="/" />
        </Switch>
      </Layout>
    );
  }
}
